import CCSSRemake from '@/views/sales/remake/ccss.vue'
import DistRemake from '@/views/sales/remake/dists.vue'
import SellinRemake from '@/views/sales/remake/sellin.vue'

export default {
  path: '/sales/remake',
  redirect: '/sales/remake/ccss',
  name: 'remake',
  meta: {
    auth: {
      redirect: {
        name: 'remake.ccss'
      },
      forbiddenRedirect: '/dashboard'
    },
    label: 'Refazer Vendas'
  },
  component: {
    render(c) {
      return c('router-view')
    }
  },
  children: [{
    path: 'ccss',
    name: 'remake.ccss',
    component: CCSSRemake,
    meta: {
      auth: true,
      label: 'CCSS'
    }
  }, {
    path: 'dists',
    name: 'remake.dists',
    component: DistRemake,
    meta: {
      auth: true,
      label: 'Dists'
    }
  }, {
    path: 'sellin',
    name: 'remake.sellin',
    component: SellinRemake,
    meta: {
      auth: true,
      label: 'Dists'
    }
  }]
}
